import axios from "axios";

const WP_API_URL = import.meta.env.VITE_WP_API_URL;

// WordPress REST API — JWT auth via interceptor
export const wpApi = axios.create({
    baseURL: WP_API_URL,
    headers: { "Content-Type": "application/json" },
});

// WooCommerce public API — products, categories (read-only, no keys needed for public data)
export const wcApi = axios.create({
    baseURL: `${WP_API_URL}/wc/v3`,
    headers: { "Content-Type": "application/json" },
});

// JWT interceptor
wpApi.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("jwt_token");
        if (token) config.headers.Authorization = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error),
);

// Token expiry handler
wpApi.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 403) {
            localStorage.removeItem("jwt_token");
            localStorage.removeItem("jwt_user");
            window.location.href = "/login";
        }
        return Promise.reject(error);
    },
);
